var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "group-read-only form-group form-group--group" },
    [
      _c("div", { staticClass: "panel panel-default" }, [
        !_vm.component.hideLabel
          ? _c("div", { staticClass: "panel-heading" }, [
              !_vm.component.hideLabel
                ? _c("h4", { staticClass: "panel-title" }, [
                    _vm._v(_vm._s(_vm.component.label)),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "panel-body" },
          [
            _vm._l(_vm.component.components, function (component, index) {
              return [
                _c(`${component.type}-read-only`, {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.$checkConditionalViewAllow(
                        component,
                        _vm.components,
                        _vm.variables,
                        _vm.json
                      ),
                      expression:
                        "!$checkConditionalViewAllow(component, components, variables, json)",
                    },
                  ],
                  key: component._uuid,
                  tag: "component",
                  attrs: {
                    component: component,
                    components: _vm.components,
                    value: _vm.jsonData[component.key],
                  },
                }),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }